import { tns } from '../../tiny-slider/src/tiny-slider';

class AppSpotlightCarousel {
  constructor() {
    this.AppSpotlightCarousel = null;
    this.navPagers = document.querySelectorAll('.js-app-spotlight-carousel-nav-pager');
    this.nav = document.querySelectorAll('.js-app-spotlight-carousel-nav');
    this.init();
    this.attachListeners();
  }

  init() {
    this.AppSpotlightCarousel = tns({
      container: '.js-app-spotlight-carousel',
      navContainer: '.js-app-spotlight-carousel-nav',
      controls: false,
      mode: 'gallery',
      autoplay: true,
      autoplayTimeout: 5000,
      autoplayButtonOutput: false,
    });
  }

  attachListeners() {
    this.nav.forEach(nav => nav.addEventListener('click', this.resumeAutoplay.bind(this)));
  }

  resumeAutoplay() {
    this.AppSpotlightCarousel.play();
  }
}

export default AppSpotlightCarousel;
